// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__pu8WY"};